import { isDingtalk } from './tools'
export const ddShare = ({ type = 0, url = window.location.href, title, content, image }) => {
    isDingtalk() &&
        import('dingtalk-jsapi').then(dd => {
            dd.ready(function () {
                dd.biz.navigation.setRight({
                    show: true,
                    control: true,
                    text: '',
                    onSuccess: function (result) {
                        console.log('设置成功----', result)
                        dd.share({
                            type: type,
                            url: url,
                            title: title,
                            content: content,
                            image: image || `${location.origin}/assets/wxshare/logo.png`,
                            onSuccess: function (res) {
                                // 调用成功时回调
                                console.log('分享成功----', res)
                            },
                            onFail: function (err) {
                                // 调用失败时回调
                                console.log('分享失败----', err)
                            },
                        })
                    },
                    onFail: function () {
                        console.log('设置失败')
                    },
                })
            })
        })
}
